import React, { useEffect } from 'react';
import UpcommingGameList from '../upcomminggames/UpcommingGameList';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import { Tab, Icon, Button } from 'semantic-ui-react';
import { currentMonth } from '../helpers/DateUtils.jsx';

const styles = {
  container: {
    minHeight: 'calc(100vh - 200px)',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
  },
  header: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '25px 30px',
    marginBottom: '25px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '15px',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  headerIcon: {
    backgroundColor: '#569556',
    borderRadius: '10px',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    margin: 0,
    fontSize: '1.8rem',
    color: '#333',
  },
  subtitle: {
    margin: 0,
    color: '#666',
    fontSize: '0.95rem',
  },
  tabsCard: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '25px',
  },
  tabPane: {
    backgroundColor: '#f9f9f9',
    padding: '20px',
    borderRadius: '0 0 8px 8px',
    minHeight: '300px',
  },
};

const Events = () => {
  useEffect(() => {
    ReactGA.ga('send', 'pageview', '/games');
  }, []);

  const currentYear = new Date().getFullYear();

  const panes = [
    {
      menuItem: { key: 'month', icon: 'calendar', content: currentMonth() },
      render: () => (
        <Tab.Pane style={styles.tabPane}>
          <UpcommingGameList view="month" />
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'year', icon: 'calendar alternate', content: String(currentYear) },
      render: () => (
        <Tab.Pane style={styles.tabPane}>
          <UpcommingGameList view="year" />
        </Tab.Pane>
      ),
    },
    {
      menuItem: { key: 'all', icon: 'list', content: 'All Games' },
      render: () => (
        <Tab.Pane style={styles.tabPane}>
          <UpcommingGameList view="all" />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.header}>
          <div style={styles.headerLeft}>
            <div style={styles.headerIcon}>
              <Icon name="game" size="large" style={{ color: 'white', margin: 0 }} />
            </div>
            <div>
              <h1 style={styles.title}>Upcoming Games</h1>
              <p style={styles.subtitle}>Click on a game date for more details</p>
            </div>
          </div>
          <Button as={Link} to="/" basic>
            <Icon name="arrow left" /> Back to Home
          </Button>
        </div>
        <div style={styles.tabsCard}>
          <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
        </div>
      </div>
    </div>
  );
};

export default Events;
